import script from "./AddPolicyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPolicyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPolicyModal.vue?vue&type=style&index=0&id=114066b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114066b4"]])

export default __exports__